import { jsx as r } from "react/jsx-runtime";
import { Modal as n, ModalSizeEnum as d } from "@systemeio/ui";
import { useRef as c, useEffect as m } from "react";
const h = ({ threeDsInfo: a, opened: e, onComplete: i }) => {
  const t = c(null);
  return m(() => {
    if (!e) return;
    const o = (s) => {
      s.origin === "https://api.mercadopago.com" && s.data.status === "COMPLETE" && i();
    };
    return window.addEventListener("message", o), () => window.removeEventListener("message", o);
  }, [e, i]), m(() => {
    e && t.current && t.current.requestSubmit();
  }, [e]), /* @__PURE__ */ r(
    n,
    {
      id: "three-ds-modal",
      size: d.small,
      title: "",
      isFetching: !0,
      opened: e,
      onClose: () => {
      },
      closeIconClassName: "hidden",
      closeIconWrapperClassName: "hidden",
      contentClassName: "flex justify-center min-h-[500px]",
      children: /* @__PURE__ */ r("iframe", { name: "mercado-3ds-iframe", id: "mercado-3ds-iframe", title: "Mercado Pago 3DS iframe", children: /* @__PURE__ */ r(
        "form",
        {
          name: "mercado-3ds-form",
          target: "mercado-3ds-iframe",
          method: "post",
          action: a.external_resource_url,
          ref: t,
          children: /* @__PURE__ */ r("input", { type: "hidden", name: "creq", value: a.creq })
        }
      ) })
    }
  );
};
export {
  h as MercadoPagoThreeDsModal
};
